import React from "react";

const DeleteButton = ({onDeleteClick}) => <div onClick={onDeleteClick}> <i className="fas fa-trash cursor-pointer p-1 text-danger" /> </div>

export default DeleteButton